import script from "./AppLayoutFooter.vue?vue&type=script&lang=ts&setup=true"
export * from "./AppLayoutFooter.vue?vue&type=script&lang=ts&setup=true"

import "./AppLayoutFooter.vue?vue&type=style&index=0&id=865b4984&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-865b4984"]])

export default __exports__